// eslint-disable-next-line no-shadow
export enum DgLandBotEventType {
  LANDBOT_INTERCOM = 'landbotIntercom',
  LANDBOT_SAT_ID = 'landbotSatId',
}
